import React from "react";

const SubtitleAndDescription = (props) => {
  const { subtitle, description, className, fontSize } = props;

  return (
    <div className={`wow-subtitle-and-description ${className ?? ""}`}>
      <div className="subtitle" style={{ fontSize: fontSize ?? "16px" }}>
        {subtitle}
      </div>
      {description ? <div className="description">{description}</div> : null}
    </div>
  );
};

export default SubtitleAndDescription;
